var map = {
	"./CN.json": "5e78",
	"./EN.json": "b8a5",
	"./ES.json": "ca5b",
	"./HI.json": "e96d",
	"./ID.json": "0fdd",
	"./JA.json": "85a2",
	"./KM.json": "b863",
	"./KO.json": "fdb4",
	"./MY.json": "a031",
	"./PT.json": "7f3c",
	"./TA.json": "ddcf",
	"./TH.json": "2349",
	"./TW.json": "192d",
	"./VI.json": "2bce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9938";